<template>
  <div>
    <v-app-bar
      app
      clipped-left
      :color="get_interface.colors.appbar"
      height="50"
      light
    >
      <v-app-bar-nav-icon class="toggle-menu" @click.stop="toggleMenu()" />
      <v-toolbar-title>
        <v-icon class="toolbar-icon" :dark="$vuetify.theme.dark">{{ this.$route.meta.icon }}</v-icon>
        {{ this.$route.meta.title | capitalize }}
      </v-toolbar-title>
      <v-spacer />
      <Notifications />
      <Config />
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      :class="get_interface.colors.navigation"
      width="250"
      app
      dark
      clipped
      hide-overlay
      :expand-on-hover="!is_mobile"
    >
      <template v-slot:prepend>
        <Avatar />
      </template>
      <v-divider></v-divider>
      <v-list dense>
        <div
          v-for="menu in $router.options.routes"
          :key="menu.name"
          @click.stop="pushRoute(menu.name)"
          @click.middle="pushRoute(menu.name, true)"
          :class="{ 'active-menu-route': (menu.name === (routerPath || {}).root) || (menu.name === 'home' && routerPath === false) }"
        >
          <v-list-item
            v-if="(typeof permissions[menu.name] !== 'undefined' && permissions[menu.name]) || (menu.name === 'test' && app_data.dev_mode)"
            link
          >
            <v-list-item-action>
              <v-icon>{{ menu.meta.icon }}</v-icon>
              <v-tooltip top v-if="(typeof get_data.notifications !== 'undefined' && typeof get_data.notifications[menu.name] !== 'undefined' && get_data.notifications[menu.name].unread > 0)">
                <template v-slot:activator="{ on }">
                  <v-btn icon small v-on="on" class="notification-alert">
                    <v-icon small color="red">mdi-exclamation-thick</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ `${get_data.notifications[menu.name].unread} ${lang.notifications.unread((get_data.notifications[menu.name].unread > 1))}` }}
                  </span>
              </v-tooltip>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ menu.display }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Config from './menus/Config'
import Notifications from './menus/Notifications'
import Avatar from './components/Avatar'

import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  components: { Config, Notifications, Avatar },
  data: () => ({
    drawer: true
  }),
  computed: {
    avatar () {
      this.user_data
      let logged_user = this.user_data || {}
      return logged_user.avatar
    }
  },
  methods: {
    toggleMenu () {
      this.drawer = !this.drawer
    },
    pushRoute (name, new_window = false) {
      if (!new_window) {
        this.$router.push({ name }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      } else {
        let routeData = this.$router.resolve({ name })
        window.open(routeData.href, '_blank')
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  created () {
    if (this.is_mobile) this.drawer = false
  }
}
</script>

<style src="@/styles/main/header.scss" lang="scss"></style>
